import decomment from 'decomment';

/**
 * 计算C++的代码行数
 * {}符号如果单独一行，不计入行数
 */
export function countLines(playerCode) {
    let lineNum = 0;
    try {
        playerCode = decomment(playerCode);
    } catch (error) {
        return 99;
    }

    let playerCodeLines = playerCode.split('\n') || [];
            
    for(var i = 0;i<playerCodeLines.length; i++){
        var lineCode = playerCodeLines[i].trim();

        if(lineCode.length == 0) continue;
        if(lineCode == '{' || lineCode == '}') continue;
        if(lineCode.startsWith('//')) continue;

        lineNum++;
    }

    return lineNum;
}


// WEBPACK FOOTER //
// ./src/libs/cppUtils.js